import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import {MatDialogModule} from '@angular/material/dialog'; 
import { ChartsModule } from 'ng2-charts';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgSelectModule } from '@ng-select/ng-select';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SignupComponent } from './signup/signup.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MentionComponent } from './mention/mention.component';
import { AnalysisComponent } from './analysis/analysis.component';
import { SourceComponent } from './source/source.component';
import { QuotesComponent } from './quotes/quotes.component';
import { CompareComponent } from './compare/compare.component';
import { AddprojectComponent } from './addproject/addproject.component';
import { EmailreportComponent } from './emailreport/emailreport.component';
import { PdfreportComponent } from './pdfreport/pdfreport.component';

import { NgxSpinnerModule } from "ngx-spinner";
import { NotFoundComponent } from './not-found/not-found.component';
import { ProjectsComponent } from './projects/projects.component';
import { AddComponent as AddProject } from './projects/add/add.component';
import { EditComponent as EditProject } from './projects/edit/edit.component';
import { ProjectsHeaderComponent } from './projects/projects-header/projects-header.component';
//import {MatTabsModule} from '@angular/material/tabs';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { UsersComponent } from './users/users.component';
import { AddComponent } from './users/add/add.component';
import { EditComponent } from './users/edit/edit.component';
import { InfographComponent } from './infograph/infograph.component';
import { ExcelReportComponent } from './excel-report/excel-report.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LogsComponent } from './logs/logs.component';
import { LoginFailuresComponent } from './login-failures/login-failures.component';
import { RequestsComponent } from './keywords/requests/requests.component';
import { ResponseComponent } from './keywords/response/response.component';


@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        HeaderComponent,
        FooterComponent,
        SignupComponent,
        DashboardComponent,
        MentionComponent,
        NotFoundComponent,
        AnalysisComponent,
        SourceComponent,
        QuotesComponent,
        CompareComponent,
        AddprojectComponent,
        EmailreportComponent,
        PdfreportComponent,
        ProjectsComponent,
        ProjectsHeaderComponent,
        UsersComponent,
        AddComponent,
        EditComponent,
        InfographComponent,
        AddProject,
        EditProject,
        ExcelReportComponent,
        ChangePasswordComponent,
        ForgotPasswordComponent,
        LogsComponent,
        LoginFailuresComponent,
        RequestsComponent,
        ResponseComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        NgxSpinnerModule,
        ChartsModule,
        NgxDaterangepickerMd.forRoot({
            format: 'YYYY-MM-DD',
            displayFormat: 'YYYY-MM-DD',
        }),
        NgxPaginationModule,
        NgxSliderModule,
        InfiniteScrollModule,
        NgSelectModule
    ],
    providers: [
        Title,
        { provide: 'BASE_URL', useFactory: getBaseUrl },
        //{ provide: LocationStrategy, useClass: HashLocationStrategy },
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent]
})

export class AppModule { }

export function getBaseUrl() {
    //return 'http://localhost/codeigniter/24ieye/api';
    return 'https://www.24ieye.com/backend/api';
}